import { render } from "./removeFloader.vue?vue&type=template&id=3d347746"
import script from "./removeFloader.vue?vue&type=script&lang=js"
export * from "./removeFloader.vue?vue&type=script&lang=js"

import "./removeFloader.vue?vue&type=style&index=0&id=3d347746&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__